import {
  stutter as stutterDuration
} from "./_keyframes.scss";

export {
  fadeIn,
  fadeOut,
  growIn,
  short as shortDuration,
  slow  as slowDuration,
  slideDown,
  slideDownOut,
  slideLeft,
  slideLeftFull,
  slideRight,
  slideRightOutFull,
  slideRightOut,
  slideUp,
  slideUpFull,
  stutter as stutterDuration,
} from "./_keyframes.scss";

export function stutter(timing) {
  return timing ? {
    animationDelay: `${stutterDuration * timing}ms`
  } : null;
}
